import AuditTrailsDataTable from "../../../components/dataTable/tables/AuditTrailsDataTable";

function AuditTrailsPageView() {
  return <AuditTrailsDataTable />;
}

export default AuditTrailsPageView;
